import axios from 'axios';
// import authHeader from './auth.header';
import {csrHandler, ssrHandler} from './axiosErrorHandler';
// Direct subpath, not the utils barrel: axiosInterceptor is reachable from every
// service (and the store in _app). The barrel re-exports authHelper -> crypto-js.
import {flatifyObject} from '@jobseeker/common-core/utils/common';
import {
  getCachedBotToken,
  isBotGuardEnabled,
} from '@jobseeker/common-core/utils/botGuard';

declare module 'axios' {
  export interface AxiosRequestConfig {
    suppressErrorToast?: boolean;
  }
}

const axiosInterceptorInstance = (baseURL: string | undefined = undefined) => {
  const instance = axios.create({
    baseURL,
    timeout: 30000,
    withCredentials: true,
  });

  instance.interceptors.request.use((req: any) => {
    req.metadata = {startTime: Date.now()};
    // if (req.headers) {
    //   req.headers = {...req.headers, ...authHeader()};
    // } else {
    //   req.headers = authHeader();
    // }
    if (process.env.NODE_ENV !== 'production') {
      console.log(req.baseURL, req.url, 'AXIOS REQUEST OUT');
    }
    try {
      if (window && window.location) {
        const urlParams = new URLSearchParams(window.location.search);
        const ref = urlParams.get('ref');
        const pref = urlParams.get('pref');
        if (!req.params) {
          req.params = {};
        }
        if (ref) {
          req.params['ref'] = ref;
          req.params['referenceText'] = ref;
        }
        if (pref) {
          req.params['pref'] = pref;
        }
        const refPool: Record<string, string> = {};
        Array.from(urlParams.entries()).forEach(([key, value]) => {
          if (value) refPool[key] = value;
        });
        if (Object.keys(refPool)?.length > 0) {
          req.params['refPool'] = JSON.stringify(refPool);
        }

        // [BotGuard]: Adding bot guard tokens for specific endpoints in iimjobs
        const botGuardedExactUrls = [
          '/detail',
          '/similarjobs',
          '/category/',
          '/recruiterfeed/',
          '/keyword/',
          '/jobfeed',
        ];
        const botGuardedPrefixUrls = ['/top-jobs', '/similar-company-jobs'];
        if (
          isBotGuardEnabled() &&
          (botGuardedExactUrls.includes(req.url) ||
            botGuardedPrefixUrls.some(prefix => req.url?.startsWith(prefix)))
        ) {
          req.headers = req.headers ?? {};
          req.headers['x-page-url'] =
            req.headers['x-page-url'] || window.location.href;
          req.headers['x-vid'] = req.headers['x-vid'] || getCachedBotToken();
        }
      }
    } catch (error) {}
    req.params = flatifyObject(req.params);
    return req;
  });

  instance.interceptors.response.use(
    response => {
      return response;
    },
    async error => {
      if (typeof window !== 'undefined') {
        const handlerInfo = await csrHandler(error);
        if (handlerInfo?.status === 200) {
          return handlerInfo;
        }
      } else {
        return await ssrHandler(error);
      }
    }
  );

  return instance;
};

export default axiosInterceptorInstance;
